export default function saveEditSuccess(state, payload) {
  const { activePlans, completePlans } = payload;

  return {
    ...state,
    activePlans,
    completePlans,
    isFetching: false,
  };
}